<script setup lang="ts">
import { useGlobalState } from './hooks/useGlobalState'

const $prors = withDefaults(defineProps<Prors>(), {
  who: '',
  data: () => [],
})
// 向父组件触发方法
const emit = defineEmits(['onClick'])
const state = useGlobalState()
// import { useGlobalQuery } from './hooks/useGlobalQuery'
// const query = useGlobalQuery()

// 接受父组件传递的参数
interface Prors {
  who?: number | string
  data?: Array<any>
}
// 向父组件暴露属性和方法
defineExpose({
  $prors,
})
/**
 * 所有点击事件集合
 * @param item { key: string , $event: PointerEvent, $prors}
 */
function onClick(item: any) {
  // emit('onClick', item)
  /* [10,20,30] 点击按钮列表 获取数据值 */
  console.log('>> onShortcutInput', item)
  state.fromMoney.amount = item
}
</script>

<template>
  <div v-if="data.length" class="flex scroll-ml-6" style="overflow-x: auto;">
    <ul v-for="(value, key) of data" :key="key" class="shortcut-select">
      <li data-test-id="fttu" @click="onClick(value)">{{ value }}</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
/* 滚动条样式 背景 */
*::-webkit-scrollbar{
  height: 10px;
}

/* 滚动条样式 滑块 */
*::-webkit-scrollbar-thumb{
  border-radius: 6px;
  background-color: #256DF0;
}

.shortcut-select {
    @media all and (width <= 600px) {
      padding: 15px 0 0;
    }

    & > * {
      padding: 6px 30px;
      border: 1.5px solid var(--secondary-text);
      border-radius: 8px;
      margin-right: 8px;
      color: var(--secondary-text);
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.5s ease-in-out;

      @media all and (width <= 600px) {
        padding: 7px 17px;
        border: 1.5px solid #6f8eca;
        color: #6f8eca;
        font-size: 13px;
      }
    }

    & > *:hover {
      --uno: "bg-[#148AF5] text-[white]";

      @media all and (width <= 600px) {
        background-color: #6f8eca;
      }
    }
  }
</style>
